import $ from 'jquery';

export const init = () => {

	$(window).on('scroll', function(e) {
		e.preventDefault();

		var $scroll = $(this).scrollTop();

		if ($scroll > 300) {
			$('.top').fadeIn();
			$('.top').css('display','flex');
		} else {
			$('.top').fadeOut();
			$('.top').css('display','none');
		}
	});

};
